import makeStyles from "@mui/styles/makeStyles";
import React, {useEffect, useRef, useState} from "react";
import Navigation from "./navigation";
import Radio from "@mui/material/Radio";
import {Cancel, CheckCircle, RadioButtonChecked, RadioButtonUnchecked} from "@mui/icons-material";
import createStyles from "@mui/material/styles/createStyles";
import IconButton from "@mui/material/IconButton";

let vh = window.innerHeight * 0.01;

const useStyles = makeStyles((theme) => createStyles({
  scrollable: {
      ['@media (max-width: 640px)']: {
        overflowY: 'scroll',
        minHeight: 100*vh-68,
        height: 'inherit',
        display: 'flex',
        flexDirection: 'column',
      },
      ['@media (min-width: 640px)']: {
        overflowY: 'scroll',
        minHeight: 720-68,
        height: 'inherit',
        display: 'flex',
        flexDirection: 'column',
      },
  },
  view: {
    border: 'inherit',
    borderRadius: 'inherit',
    minHeight: 'inherit',
    height: '100%',
    display: 'flex',
    flexFlow: 'column',
  },
  header: {
    flex: '0 1 auto',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    background: 'linear-gradient(180.02deg, #FF8A00 0.02%, #58AF56 121.49%, #58AF56 180.83%)',
    ['@media (min-width: 640px)']: {
      borderRadius: '19px 19px 0 0',
    },
    top: 0,
    left: 0,
    minHeight: 'fit-content',
    height: 'fit-content',
    width: '100%',
    paddingTop: '10px',
    margin: 0,
  },
  image: {
    height: '80px',
    width: '60px',
  },
  optionRow: {
    display: 'flex',
    flexDirection: 'col',
    justifyContent: 'center',
    alignItems: 'center',
  },
  number: {
    fontWeight: 'bold',
    marginLeft: '10px',
    marginRight: '20px',
    width: '20%',
    paddingTop: 0,
    fontStyle: 'normal',
    fontSize: '16px',
    lineHeight: '20px',
  },
  question: {
    ['@media (max-width: 400px)']: {
      fontSize: '16px',
      lineHeight: '20px',
    },
    width: '80%',
    paddingTop: 0,
    textAlign: 'left',
    fontStyle: 'normal',
    fontSize: '18px',
    lineHeight: '25px',
    marginRight: '30px',
  },
  option: {
    width: '60%',
    textAlign: 'left',
    fontStyle: 'normal',
    fontSize: '18px',
    lineHeight: '25px',
  },
  main: {
    flex: '1 1 auto',
    background: '#E8E8E8',
    marginTop: '20px',
    width: '100%',
    padding: 0,
    margin: 0,
    left: 0,
  },
  explanation: {
    flex: '0 1 auto',
    bottom: 0,
    width: '90%',
    marginLeft: '5%',
    marginRight: '5%',
    marginTop: '20px',
    marginBottom: '20px',
    boxSizing: "border-box",
    borderRadius: '10px',
    boxShadow: '5px 5px 5px 5px rgb(0 0 0 / 0.2)',
    maxWidth: 'inherit',
    height: 'fit-content',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    ['@media (min-width: 640px)']: {
          width: '400px',
          height: '90%',
          marginTop: '20px',
          marginBottom: '20px',
          marginLeft: '120px',
          marginRight: '120px',
          // border: "1px solid #000000",
          boxSizing: "border-box",
          borderRadius: '20px',
          boxShadow: '5px 5px 5px 5px rgb(0 0 0 / 0.2)',
      }
  },
  explanationCorrect: {
    background: 'linear-gradient(180deg, #C0CA41 0%, #7EA743 100%)',
  },
  explanationIncorrect: {
    background: 'linear-gradient(180deg, #F68E06 0%, #AC760C 87.5%)'
  },
  textHeader: {
    fontStyle: 'normal',
    fontSize: '20px',
    fontWeight: 'bold',
    lineHeight: '15px',
    textAlign: 'center',
    marginBottom: '5px',
    color: '#000000',
  },
  textInstruction: {
      fontStyle: 'normal',
      fontSize: '18px',
      ['@media (max-width: 400px)']: {
        fontSize: '16px',
        lineHeight: '20px',
      },
      lineHeight: '23px',
      textAlign: 'center',
      color: '#000000',
      maxWidth: '400px',
      marginLeft: '20px',
      marginRight: '20px',
  },
}));

export default function Question(props) {
  const {
    questionId,
    totalQuestions,
    prevHandler,
    nextHandler,
    setCurrentQuestionId,
    currentAnswers,
    setCurrentAnswers,
    correctAnswers,
    setCorrectAnswers,
    setQuizFinished,
  } = props;
  const classes = useStyles();
  const [selectedOption, setSelectedOption] = useState(undefined);
  const [question, setQuestion] = useState(undefined);
  const [answerChecked, setAnswerChecked] = useState(false);
  const explanationRef = useRef(undefined);

  const scrollToRef = (ref) => {
    if (ref.current && (answerChecked || (
      currentAnswers[questionId] &&
      correctAnswers[questionId]))) {
      document.getElementsByClassName(classes.scrollable)[0].scrollTo({
        top: ref.current.offsetTop-10,
        left: 0,
        behavior: "smooth"
      });
    }
  };

  const handleChange = (event) => {
    setSelectedOption(event.target.value);
  }

  const handleAnswerCheck = () => {
    if (selectedOption) {
      const correctAnswer = question.answer;
      const displayAnswer = question.displayAnswer;
      setCurrentAnswers({[questionId]: selectedOption, ...currentAnswers});
      setCorrectAnswers({[questionId]: {option: correctAnswer, displayAnswer}, ...correctAnswers});
      setAnswerChecked(true);
    }
  }

  useEffect(() => {
    if (answerChecked) {
      explanationRef.current && scrollToRef(explanationRef);
    }
  }, [answerChecked])

  useEffect(() => {

  }, [questionId]);

  useEffect(() => {
    if (currentAnswers[questionId]) {
      setAnswerChecked(true);
    } else {
      setAnswerChecked(false);
      setSelectedOption(undefined);
      document.getElementsByClassName(classes.scrollable)[0] && document.getElementsByClassName(classes.scrollable)[0].scrollTo(0, 0)
    }
      fetch(`/quiz-klimatyczny/questions/${questionId}.json`).then((response) => response.json()).then(setQuestion);
    }, [questionId]
  );

  const getProgressIcon = (key) => {
    if (key === questionId) {
      if (currentAnswers[key] && correctAnswers[key]){
        return currentAnswers[key] === correctAnswers[key].option ?
          (<CheckCircle style={{color: 'rgb(0,128,0,1)', fontSize: '20px'}} onClick={setCurrentQuestionId}/>) :
          (<Cancel style={{color: 'rgb(255,165,0,1)', fontSize: '20px'}}/>)
      } else {
        return (<RadioButtonChecked style={{color: 'rgb(0,0,0)', fontSize: '20px'}}/>)
      }
    } else {
      if (currentAnswers[key] && correctAnswers[key]){
        return currentAnswers[key] === correctAnswers[key].option ?
          (<CheckCircle style={{color: 'rgb(0,128,0,0.5)', fontSize: '20px'}}/>) :
          (<Cancel style={{color: 'rgb(255,165,0,0.5)', fontSize: '20px'}}/>)
      } else {
        return (<RadioButtonUnchecked style={{color: 'rgb(0,0,0, 0.5)', fontSize: '20px'}}/>)
      }
    }
  }

  const getOptionIconAfterCheck = (key) => {
    if (key === question.answer) {
      return (<CheckCircle style={{color: 'green'}}/>);
    } else if (key === selectedOption || key === currentAnswers[questionId]) {
      return (<Cancel style={{color: 'orange'}}/>);
    } else {
      return (<RadioButtonUnchecked style={{color: 'rgb(0,0,0,0.5)'}}/>)
    }
  }

  if (answerChecked || (
      currentAnswers[questionId] &&
      correctAnswers[questionId]
      // currentAnswers[questionId] === correctAnswers[questionId].option
    )) {
    return (
      question ?
      <div className={classes.view}>
        <div className={classes.scrollable}>
          <header className={classes.header}>
            <p className={classes.number}>{`${questionId} / ${totalQuestions}`}</p>
            <p className={classes.question}>{question.question}</p>
          </header>
          <main className={classes.main}>
            {
              Object.entries(question.options).map(([key, option]) => (
              <div className={classes.optionRow}>
                <div style={{width: '48px',
                             height: '60px',
                             display: 'flex',
                             justifyContent: 'center',
                             alignItems: 'center'}}>{getOptionIconAfterCheck(key)}</div>
                <p className={classes.option} style={{color: (correctAnswers[questionId] && key === correctAnswers[questionId].option ? 'black' : 'rgb(0,0,0,0.5)')}}>{option}</p>
              </div>
              ))
            }
            <div style={{flex: '1 1 auto'}}/>
            {question.answer === selectedOption || (currentAnswers[questionId] && correctAnswers[questionId] && currentAnswers[questionId] === correctAnswers[questionId].option) ?
              <div ref={explanationRef} className={`${classes.explanation} ${classes.explanationCorrect}`} id='explanation'>
                <h6 className={classes.textHeader}>DOBRA ODPOWIEDŹ</h6>
                <img src={'noun-heat-wave-3189081 2.svg'} className={classes.image}/>
                <p className={classes.textInstruction}>Uzasadnienie:</p>
                <p className={classes.textInstruction}>{question.explanation}</p>
              </div> :
              <div ref={explanationRef} className={`${classes.explanation} ${classes.explanationIncorrect}`}>
                <h6 className={classes.textHeader}>ZŁA ODPOWIEDŹ</h6>
                <img src={'noun-heat-wave-3189081 2.svg'} className={classes.image}/>
                <p className={classes.textInstruction}>Uzasadnienie:</p>
                <p className={classes.textInstruction}>{question.explanation}</p>
              </div>
              }
            {(questionId === totalQuestions && Object.keys(currentAnswers).length !== totalQuestions) &&
            <div className={classes.explanation}>
              <p className={classes.textInstruction}>Odpowiedz na wszystkie pytania, żeby zakończyć quiz</p>
            </div>}
          </main>
          <div style={{flex: '0 1 auto', marginTop: '10px', marginLeft: '8px', marginRight: '8px', marginBottom: '10px'}}>
            {
              [...Array(totalQuestions).keys()].map((key) =>
                (
                  <IconButton style={{color: 'black'}} style={{padding: 0}} onClick={() => setCurrentQuestionId(key+1)}>
                    {getProgressIcon(key + 1)}
                  </IconButton>
                )
              )
            }
          </div>
        </div>
        {questionId === totalQuestions && Object.keys(currentAnswers).length === totalQuestions ?
        <Navigation previousHandler={questionId > 1 ? prevHandler : undefined}
                nextHandler={questionId < totalQuestions ? nextHandler : undefined}
                buttonHandler={setQuizFinished}
                buttonText="kończę quiz"/>
          :
        <Navigation previousHandler={questionId > 1 ? prevHandler : undefined}
                    nextHandler={questionId < totalQuestions ? nextHandler : undefined}
                    buttonText="sprawdzam"/>
        }
        </div> :
      <></>
    );
  }
  return (
    question ?
      <div className={classes.view}>
        <div className={classes.scrollable}>
          <header className={classes.header}>
            <p className={classes.number}>{`${questionId} / ${totalQuestions}`}</p>
            <p className={classes.question}>{question.question}</p>
          </header>
          <main className={classes.main}>
            {
              Object.entries(question.options).map(([key, option]) => (
                <div className={classes.optionRow}>
                  <Radio checked={selectedOption === key}
                         onChange={handleChange}
                         style={{color: 'black', width: '48px', height: '48px'}}
                         value={key}
                         name="radio-buttons"
                         key={key}
                  />
                  <p className={classes.option} onClick={() => setSelectedOption(key)}>{option}</p>
                </div>
              ))
            }
          </main>
          <div style={{flex: '1 1 auto'}}/>
          <div style={{flex: '0 1 auto', marginTop: '10px', marginLeft: '8px', marginRight: '8px', marginBottom: '10px'}}>
              {
                [...Array(totalQuestions).keys()].map((key) =>
                  (
                    <IconButton style={{color: 'black'}} style={{padding: 0}} onClick={() => setCurrentQuestionId(key+1)}>
                      {getProgressIcon(key + 1)}
                    </IconButton>
                  )
                )
              }
          </div>
        </div>
        <Navigation previousHandler={questionId > 1 ? prevHandler : undefined}
                    nextHandler={questionId < totalQuestions ? nextHandler : undefined}
                    buttonHandler={handleAnswerCheck}
                    buttonText="sprawdzam"
        />
      </div> :
      <></>
  );
}